import React, { useContext } from "react";
import { Sidebar, SidebarItem, SidebarItemGroup } from "@msi/cobalt-react/sidebar";
import { Dropdown, DropdownItem } from "@msi/cobalt-react/dropdown";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import BatchUpload from "../BatchUpload/BatchUpload";
import "./Sidebar.css";
import { BatchUploadContext } from "../BatchUpload/BatchUploadContext";
import BetaLabsGate from "../BetaLabsGate/BetaLabsGate";
import { BETA_FEATURES } from "../../contexts/BetaLabsContext";
import { isUserAdmin } from "../../helpers/adminAuth";

interface SidebarComponentProps {
  isExpanded?: boolean;
}

const SidebarComponent: React.FC<SidebarComponentProps> = ({ isExpanded = true }) => {
  const navigate = useNavigate();
  const { authState } = useOktaAuth();
  const { setShowBatchUpload } = useContext(BatchUploadContext);

  return (
    <Sidebar
      className="SidebarComponent"
      initialSelectedItem="Home"
      isExpanded={isExpanded}
    >
      <SidebarItemGroup className="no-background-color">
        <Dropdown
          position="right"
          anchor={() => (
            <SidebarItem
              icon="ic_add"
              className="AddApiDropdown"
              label="Add API"
              isFlyout={true}
            />
          )}
        >
          <DropdownItem
            key="/add-record"
            onClick={() => navigate("/add-record")}
          >
            Add Single API
          </DropdownItem>
          <DropdownItem
            key="batch-upload"
            onClick={() => setShowBatchUpload(true)}
          >
            Batch Upload
          </DropdownItem>
        </Dropdown>
        <SidebarItem
          key="/"
          label="Home"
          icon="ic_home"
          onClick={() => navigate("/")}
        />
        <SidebarItem
          key="/table-view"
          label="Table View"
          icon="ic_data_table"
          onClick={() => navigate("/table-view")}
        />        
        <SidebarItem
          key="/diagram-v2"
          label="Diagram View"
          icon="ic_connections"
          onClick={() => navigate("/diagram-v2")}
        />
        <BetaLabsGate featureKey={BETA_FEATURES.INTEGRATION_MAPPER}>
          <SidebarItem
            key="/workflow-builder"
            label="Integration Mapper & Builder"
            icon="ic_settings"
            onClick={() => navigate("/workflow-builder")}
          />
        </BetaLabsGate>
        <BetaLabsGate featureKey={BETA_FEATURES.INTEGRATION_ECOSYSTEM}>
          <SidebarItem
            key="/integration-visualization"
            label="Integration Ecosystem"
            icon="ic_workflow"
            onClick={() => navigate("/integration-visualization")}
          />
        </BetaLabsGate>
        <SidebarItem
          key="/chat-with-ai"
          label="API Concierge"
          onClick={() => navigate("/chat-with-ai")}
          icon="ic_notify_messages_multiple"
        />
        {!authState?.isPending && isUserAdmin(authState) && (
          <SidebarItem
            key="/admin"
            label="Admin"
            onClick={() => navigate("/admin")}
            icon="ic_contacts_security"
          />
        )}
      </SidebarItemGroup>
    </Sidebar>
  );
};

export default SidebarComponent;